import styled, { css } from 'styled-components';
import { grey } from '@material-ui/core/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 0 0 auto;
  align-items: center;
  border-bottom: 1px solid var(--border-dark-color);
  margin: 0;
  padding: 0.75rem;

  ${(props) => props.prime
    && css`
      position: sticky;
      top: 110px;
      z-index: 9;

      background: linear-gradient(#dc2b7b, #c64751);
      color: ${grey[300]};

      border-bottom: none;
    `};
`;

export const IconWrapper = styled.div`
  margin-right: 1rem;
  img {
    height: 40px;
    border-radius: 25rem;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;

export const LinkTitle = styled.h3`
  font-weight: 800;
  font-size: 1em;
  margin: 0;
`;

export const LinkSubtitle = styled.p`
  margin: 0;
  font-size: 0.9em;
`;

export const ActionWrapper = styled.div`
  display: flex;
  margin-left: auto;
`;

export const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  border: 1px solid var(--button-border-dark-color);
  border-radius: 0.5rem;

  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;

  min-width: 80px;
  padding: 0.5rem 0.1rem;

  ${(props) => props.prime
    && css`
      background-color: white;
      color: ${grey[900]};

      border: none;
    `}
`;
